module.exports = __webpack_public_path__ + "img/ilunga.bb612a5d.jpg";